export const SET_USER_CREATED = 'USER/SET_USER_CREATED';
export const SET_USER_STATE = 'USER/SET_USER_STATE';
export const SET_EMAIL_CONSENT = 'USER/SET_EMAIL_CONSENT';
export const SET_SIGNED_UP_FOR_NEWSLETTER = 'USER/SET_SIGNED_UP_FOR_NEWSLETTER';
export const CLOSE_PROFILE_INFO = 'USER/CLOSE_PROFILE_INFO';
export const SHOW_NOTIFICATION_INDICATOR = 'USER/SHOW_NOTIFICATION_INDICATOR';
export const HIDE_NOTIFICATION_INDICATOR = 'USER/HIDE_NOTIFICATION_INDICATOR';
export const REMOVE_LEAD_VEHICLE_LISTS = 'USER/REMOVE_LEAD_VEHICLE_LISTS';
